import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import { ErrorText } from '../../../components';
import { DELIVERY_CHARGE, NON_TILE_CHARGE } from '../../../constants';

const MAX_VALUE = 100000000;
const FORM_KEYS = [
    'maximumKilometers',
    'minimumAmount',
    // 'chargePerTon',
    // 'reductionPerTon',
    // 'incrementReductionBy',
    // 'chargePerKilometer',
    // 'chargeBy',
    'nonTileProducts'
]

export default class SlotModal extends Component {
    constructor() {
        super()
        this.state = this.getInitState();
    }

    getInitState = () => ({
        form: {
            maximumKilometers: 0,
            minimumAmount: 0,
            // chargePerTon: '',
            // reductionPerTon: '',
            // incrementReductionBy: '',
            // chargePerKilometer: '',

            nonTileProducts: { chargeBy: 1 }
        },
        errors: {}
    });
    componentDidMount() {
        console.log(this.props.data);
        if (this.props.data) {
            this.setEditMode();
        }
        else {
            this.state = this.getInitState();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.setEditMode();
        }
    }

    setEditMode = () => {
        this.setState({
            form: FORM_KEYS.reduce((acc, key) => { acc[key] = this.props.data[key]; return acc; }, {})
        })
    }

    onInputChange = e => {
        const { target: { name, value } } = e
        this.setState(state => ({
            form: {
                ...state.form,
                [name]: value,
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }))
    }
    onNonTileChange = (e) => {
        const { target: { name, value } } = e
        this.setState(state => ({
            form: {
                ...state.form,
                nonTileProducts: {
                    ...state.form.nonTileProducts,
                    [name]: value
                },
                // nonTileProducts:{[name]: value}
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }))
    }

    onClose = () => {
        this.setState(this.getInitState());
        this.props.onHide();
    }

    onSubmit = e => {
        e.preventDefault();
        if (!this.validateForm()) return
        const { form } = this.state;
        this.props[this.props.data ? 'updateSlot' : 'addSlot']({ ...form });
    }

    validateForm = () => {
        const { form } = this.state
        const errors = {}

        Object.keys(form).map(key => {
            if (!form[key]) errors[key] = 'Required';
            else if (form[key] < 0 || form[key] > MAX_VALUE) errors[key] = 'Invalid';
        })

        this.setState({ errors });

        return isEmpty(errors)
    }


    render() {
        const { show } = this.props;
        const { form, errors } = this.state;
        return (
            <Modal
                show={show}
                onHide={this.onClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Slot
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames({ 'text-danger': errors.maximumKilometers })}>Max. Kilometers</label>
                                <input
                                    name="maximumKilometers"
                                    type="number"
                                    className={classNames('form-control', { 'is-invalid': errors.maximumKilometers })}
                                    value={form.maximumKilometers}
                                    onChange={this.onInputChange}
                                />
                                <ErrorText error={errors.maximumKilometers} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames({ 'text-danger': errors.minimumAmount })}>Min. Amount</label>
                                <input
                                    name="minimumAmount"
                                    type="number"
                                    className={classNames('form-control', { 'is-invalid': errors.minimumAmount })}
                                    value={form.minimumAmount}
                                    onChange={this.onInputChange}
                                />
                                <ErrorText error={errors.minimumAmount} />
                            </div>
                        </div>
                        {/* <div className="col-md-12"> 
                    <h5>Non-tile products charges</h5>
                    </div> */}
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames('font-weight-bold', { 'text-danger': errors.chargeBy })}>Non-tile products charges</label>
                                <select
                                    name="chargeBy"
                                    className={classNames('form-control', { 'is-invalid': errors.chargeBy })}
                                    value={form.chargeBy}
                                    onChange={this.onNonTileChange}
                                >
                                    {/* <option disabled value="">Select</option> */}
                                    {NON_TILE_CHARGE.map(item => <option key={item.value} value={item.value}>{item.name}</option>)}
                                </select>
                                <ErrorText error={errors.chargeBy} />
                            </div>
                        </div>
                        {form.nonTileProducts.chargeBy == 1 ? (
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className={classNames({ 'text-danger': errors.amountToCharge })}>Amount</label>
                                    <input
                                        name="amountToCharge"
                                        type="number"
                                        className={classNames('form-control', { 'is-invalid': errors.amountToCharge })}
                                        value={form.nonTileProducts.amountToCharge}
                                        onChange={this.onNonTileChange}
                                    />
                                    <ErrorText error={errors.amountToCharge} />
                                </div>
                            </div>
                        ) :
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className={classNames({ 'text-danger': errors.percentageToCharge })}>Percentage</label>
                                    <input
                                        name="percentageToCharge"
                                        type="number"
                                        className={classNames('form-control', { 'is-invalid': errors.percentageToCharge })}
                                        value={form.nonTileProducts.percentageToCharge}
                                        onChange={this.onNonTileChange}
                                    />
                                    <ErrorText error={errors.percentageToCharge} />
                                </div>
                            </div>}


                        {/* <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.chargePerKilometer})}>Charge Per Kilometer</label>
                            <input
                                name="chargePerKilometer"
                                type="number"
                                className={classNames('form-control', { 'is-invalid': errors.chargePerKilometer })} 
                                value={form.chargePerKilometer}
                                onChange={this.onInputChange}
                            />
                            <ErrorText error={errors.chargePerKilometer}/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.chargePerTon})}>Charge Per Ton</label>
                            <input
                                name="chargePerTon"
                                type="number"
                                className={classNames('form-control', { 'is-invalid': errors.chargePerTon })} 
                                value={form.chargePerTon}
                                onChange={this.onInputChange}
                            />
                            <ErrorText error={errors.chargePerTon}/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.reductionPerTon})}>Reduction Per Ton</label>
                            <input
                                name="reductionPerTon"
                                type="number"
                                className={classNames('form-control', { 'is-invalid': errors.reductionPerTon })} 
                                value={form.reductionPerTon}
                                onChange={this.onInputChange}
                            />
                            <ErrorText error={errors.reductionPerTon}/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.incrementReductionBy})}>Increment Reduction By</label>
                            <input
                                name="incrementReductionBy"
                                type="number"
                                className={classNames('form-control', { 'is-invalid': errors.incrementReductionBy })} 
                                value={form.incrementReductionBy}
                                onChange={this.onInputChange}
                            />
                            <ErrorText error={errors.incrementReductionBy}/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.chargeBy})}>Charge By</label>
                            <select
                                name="chargeBy"
                                className={classNames('form-control', { 'is-invalid': errors.chargeBy })} 
                                value={form.chargeBy}
                                onChange={this.onInputChange}
                            >
                                <option disabled value="">Select</option>
                                {DELIVERY_CHARGE.map(item => <option key={item.value} value={item.value}>{item.name}</option>)}
                            </select>
                            <ErrorText error={errors.chargeBy}/>
                        </div>
                    </div> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={this.onClose}>Close</button>
                    <button className="btn btn-primary" onClick={this.onSubmit}>Save</button>
                </Modal.Footer>
            </Modal>
        )
    }
}